import './../cine-school-main.js'
import { createApp } from 'vue'

import MasterLoader from './apps/MasterLoader.vue'
import PlayingNowStrip from './apps/PlayingNowStrip.vue'
import NewsCardsSlide from './apps/NewsCardsSlide.vue'
import ImageSlide from './apps/ImageSlide.vue'
import ComingSoonStrip from './apps/ComingSoonStrip.vue'
import HeroSliderStrip from './apps/HeroSliderStrip.vue'
import NewsTabs from './apps/NewsTabs.vue'
import MiddleVideo from './apps/MiddleVideo.vue'
import SearchModal from './apps/SearchModal.vue'
import PreOrderStripApp from './apps/PreOrderStripApp.vue'
import BreadcrumbApp from './apps/BreadcrumbApp.vue'
import MovieOverviewApp from './apps/MovieOverviewApp.vue'
import TrailerStandAloneApp from './apps/TrailerStandAloneApp.vue'
import SingleReminderStripApp from './apps/SingleReminderStripApp.vue'
import ComingSoonPage from './apps/ComingSoonPage.vue'
import NewsSubscribeForm from './apps/NewsSubscribeForm.vue'
import PreBookingStepApp from './apps/PreBookingStepApp.vue'
import ContactFormApp from './apps/ContactFormApp.vue'
import SinglePayment from './apps/SinglePayment.vue'
import MyPurchases from './apps/MyPurchases.vue'
import MovieSnapshots from './apps/MovieSnapshots.vue'
import CinemaRoomType from './apps/CinemaRoomType.vue'
import InterestFormApp from './apps/InterestFormApp.vue'
import GuideApp from './apps/GuideApp.vue'

import { createPinia } from 'pinia'

if (document.getElementById('master-loader')) {
  const app = createApp(MasterLoader)
  app.mount('#master-loader')
}

// playing-now-strip-app
if (document.getElementById('playing-now-strip-app')) {
  const { dictionary, configuration } = window['nowPlayingData']
  const app = createApp(PlayingNowStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#playing-now-strip-app')
}

if (document.querySelectorAll('[id^="multiple-card-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-card-slider-app"]')
    .forEach((cardsItem) => {
      const suffix = cardsItem.id.replace('multiple-card-slider-app-', '')
      const { dictionary, configuration } =
        window[`multiCardSliderData${suffix}`]
      const app = createApp(NewsCardsSlide)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${cardsItem.id}`)
    })
}

if (document.querySelectorAll('[id^="multiple-image-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-image-slider-app"]')
    .forEach((galleryItem) => {
      const suffix = galleryItem.id.replace('multiple-image-slider-app-', '')
      const { dictionary, configuration } =
        window[`multiImageSliderData${suffix}`]
      const app = createApp(ImageSlide)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${galleryItem.id}`)
    })
}

if (document.querySelectorAll('[id^="multiple-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-slider-app"]')
    .forEach((galleryItem) => {
      const suffix = galleryItem.id.replace('multiple-slider-app-', '')
      const { dictionary, configuration } = window[`multiSliderData${suffix}`]
      const app = createApp(MovieSnapshots)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${galleryItem.id}`)
    })
}

// coming-soon-strip-app
if (document.getElementById('coming-soon-strip-app')) {
  const { dictionary, configuration } = window['comingSoonStripData']
  const app = createApp(ComingSoonStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#coming-soon-strip-app')
}

// coming-soon-strip-app
if (document.getElementById('coming-soon-page-app')) {
  const app = createApp(ComingSoonPage)

  app.mount('#coming-soon-page-app')
}

// featured-header-strip-app
if (document.getElementById('hero-slider-strip-app')) {
  const { dictionary, configuration } = window['heroSliderStripData']
  const app = createApp(HeroSliderStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#hero-slider-strip-app')
}

if (document.getElementById('news-tabs-strip-app')) {
  const { dictionary, configuration } = window['NewsTabsData']
  const app = createApp(NewsTabs)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#news-tabs-strip-app')
}

// middle Video
if (document.getElementById('middle-video-app')) {
  const { dictionary, configuration } = window['middleVideoData']
  const app = createApp(MiddleVideo)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#middle-video-app')
}

// search modal app
const SearchModalId = 'search-modal-app'
if (document.getElementById(SearchModalId)) {
  const { dictionary, configuration } = window['searchModalData']
  const app = createApp(SearchModal)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount(`#${SearchModalId}`)
}

// pre order app
const PreOrderAppId = 'pre-order-strip-app'
if (document.getElementById(PreOrderAppId)) {
  const { dictionary, configuration } = window['preOrderData']
  const app = createApp(PreOrderStripApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${PreOrderAppId}`)
}

// breadcrumb app
const breadcrumbAppId = 'breadcrumb-app'
if (document.getElementById(breadcrumbAppId)) {
  const { dictionary, configuration } = window['breadcrumbData']
  const app = createApp(BreadcrumbApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${breadcrumbAppId}`)
}

// create voucher app
const MovieOverviewAppId = 'movie-overview-app'
if (document.getElementById(MovieOverviewAppId)) {
  const { dictionary, configuration } = window['movieOverviewData']
  const app = createApp(MovieOverviewApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${MovieOverviewAppId}`)
}

// TrailerStandAloneApp
if (document.getElementById('trailer-stand-alone-app')) {
  const app = createApp(TrailerStandAloneApp)
  app.mount('#trailer-stand-alone-app')
}

// SingleReminderStripApp
if (document.getElementById('single-reminder-app')) {
  const { dictionary, configuration } = window['comingSoonStripData']
  const app = createApp(SingleReminderStripApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#single-reminder-app')
}

// ContactFormApp
if (document.getElementById('contact-form-app')) {
  const { dictionary, configuration } = window['contactFormAppData']
  const app = createApp(ContactFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#contact-form-app')
}

// news-letter-form
const NewsSubscribeFormId = 'news-subscribe-form'
if (document.getElementById(NewsSubscribeFormId)) {
  const { dictionary, configuration } = window['newsLetterFormData']
  const app = createApp(NewsSubscribeForm)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount(`#${NewsSubscribeFormId}`)
}

// pre-booking-step for movie details page
const PreBookingStepAppId = 'pre-booking-step-app'
if (document.getElementById(PreBookingStepAppId)) {
  const { dictionary, configuration } = window['movieDetailsData']
  const app = createApp(PreBookingStepApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())
  app.mount(`#${PreBookingStepAppId}`)
}

const SinglePaymentId = 'single-payment-app'
if (document.getElementById(SinglePaymentId)) {
  const { dictionary, configuration } = window['singlePaymentData']
  const app = createApp(SinglePayment)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())
  app.mount(`#${SinglePaymentId}`)
}

if (document.getElementById('app-my-purchases')) {
  const { dictionary, configuration } = window['myPurchasesData']
  const app = createApp(MyPurchases)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-my-purchases')
}

jQuery('.master-loader').remove()

// cinema room type
if (document.getElementById('cinema-room-type-app')) {
  const { dictionary, configuration } = window['cinemaRoomTypeData']
  const app = createApp(CinemaRoomType)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#cinema-room-type-app')
}

// interest form
if (document.getElementById('interest-form-app')) {
  const { dictionary, configuration } = window['interestFormAppData']
  const app = createApp(InterestFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.use(createPinia())
  app.mount('#interest-form-app')
}

// guide app
if (document.getElementById('guide-app')) {
  const { tabs } = window['guideData']
  const app = createApp(GuideApp)

  Object.assign(app.config.globalProperties, { tabs: tabs })

  app.mount('#guide-app')
}
